/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */
import {
    Box,
    Divider,
    LinearProgress,
    Stack,
    Tooltip,
    Typography,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { styled } from "@mui/material/styles";

const ReelsProgress = styled(LinearProgress)(({ theme }) => ({
    height: 8,
    borderRadius: 4,
    width: "100%",
    backgroundColor: "#F0F0F0",
    "& .MuiLinearProgress-bar": {
        borderRadius: 4,
        background: "#f444f0",
    },
}));

const Views = ({ data }) => {
    // console.log(data);

    // Add null check for data
    if (!data) {
        return null;
    }

    const followers =
        (data?.followers?.raw_data?.total_value?.breakdowns?.[0]?.results?.find(
            (item) => item?.dimension_values?.[0] === "FOLLOWER"
        )?.value /
            data?.followers?.raw_data?.total_value?.value) *
            100 || 0;
    const nonFollowers =
        (data?.followers?.raw_data?.total_value?.breakdowns?.[0]?.results?.find(
            (item) => item?.dimension_values?.[0] === "NON_FOLLOWER"
        )?.value /
            data?.followers?.raw_data?.total_value?.value) *
            100 || 0;

    return (
        <Box>
            <Box
                display={"flex"}
                alignItems={"center"}
                gap={0.5}
                margin={"3rem 0 0 0"}
            >
                <Typography variant="h6">Views</Typography>

                <Tooltip
                    title={
                        data?.followers?.raw_data?.description ||
                        data?.content?.raw_data?.description ||
                        ""
                    }
                    arrow
                >
                    {/* <Button sx={{ padding: 0 }}> */}
                    <InfoIcon fontSize="small" sx={{ margin: 0 }} />
                    {/* </Button> */}
                </Tooltip>
            </Box>

            <Box
                display={"flex"}
                alignItems={"center"}
                margin={"0.5rem 0 0 0"}
                gap={"1rem"}
                justifyContent={"space-around"}
            >
                {data?.followers &&
                    Object.keys(data?.followers || {}).length > 0 && (
                        <Box width={"30%"}>
                            <Typography variant="h6">
                                {data?.followers?.raw_data?.total_value
                                    ?.value || 0}
                            </Typography>
                            <Typography component="p" fontSize={"0.85rem"}>
                                Views
                            </Typography>

                            <Box
                                margin={"1rem 0 0 0"}
                                display={"flex"}
                                alignItems={"center"}
                                gap={0.5}
                                justifyContent={"space-between"}
                            >
                                <Typography component="p">Followers</Typography>
                                <Typography component="p" fontWeight={600}>
                                    {(followers || 0).toFixed(1)}%
                                </Typography>
                            </Box>

                            <Box
                                margin={"1rem 0 0 0"}
                                display={"flex"}
                                alignItems={"center"}
                                gap={0.5}
                                justifyContent={"space-between"}
                            >
                                <Typography component="p">
                                    Non-Followers
                                </Typography>
                                <Typography component="p" fontWeight={600}>
                                    {(nonFollowers || 0).toFixed(1)}%
                                </Typography>
                            </Box>
                        </Box>
                    )}

                <Divider orientation="vertical" flexItem />

                {data?.content &&
                    Object.keys(data?.content || {}).length > 0 && (
                        <Box width={"60%"}>
                            <Typography variant="h6">
                                By content type
                            </Typography>

                            <Box
                                sx={{
                                    width: "100%",
                                    maxWidth: 500,
                                    pt: 3,
                                }}
                            >
                                <Stack spacing={1} sx={{ width: "100%" }}>
                                    {data?.content?.raw_data?.total_value?.breakdowns?.[0]?.results?.map(
                                        (stat) => {
                                            if (!stat) return null;

                                            return (
                                                <Box
                                                    key={
                                                        stat
                                                            ?.dimension_values?.[0] ||
                                                        "unknown"
                                                    }
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                            "space-between",
                                                        width: "100%",
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            color: "black",
                                                            fontWeight: 500,
                                                            width: "30%",
                                                            maxWidth: "30%",
                                                            fontSize: "0.85rem",
                                                            // textTransform: 'capitalize',
                                                            wordBreak:
                                                                "break-word",
                                                        }}
                                                        component={"p"}
                                                    >
                                                        {(
                                                            stat
                                                                ?.dimension_values?.[0] ||
                                                            ""
                                                        )
                                                            .split("_")
                                                            .map(
                                                                (t) =>
                                                                    t
                                                                        ?.charAt(
                                                                            0
                                                                        )
                                                                        ?.toUpperCase() +
                                                                    t
                                                                        ?.slice(
                                                                            1
                                                                        )
                                                                        ?.toLowerCase()
                                                            )
                                                            .join(" ")}
                                                    </Typography>
                                                    <Box
                                                        sx={{
                                                            flexGrow: 1,
                                                            mx: 2,
                                                        }}
                                                    >
                                                        <ReelsProgress
                                                            variant="determinate"
                                                            value={
                                                                (stat?.value /
                                                                    data
                                                                        ?.content
                                                                        ?.raw_data
                                                                        ?.total_value
                                                                        ?.value) *
                                                                    100 || 0
                                                            }
                                                        />
                                                    </Box>
                                                    <Typography
                                                        sx={{
                                                            color: "black",
                                                            fontWeight: 500,
                                                            width: "3rem",
                                                            textAlign: "right",
                                                        }}
                                                    >
                                                        {(
                                                            (stat?.value /
                                                                data?.content
                                                                    ?.raw_data
                                                                    ?.total_value
                                                                    ?.value) *
                                                                100 || 0
                                                        ).toFixed(1)}
                                                        %
                                                    </Typography>
                                                </Box>
                                            );
                                        }
                                    ) || []}
                                </Stack>

                                <Typography
                                    fontSize={"0.7rem"}
                                    textAlign="center"
                                    marginTop={"1.5rem"}
                                >
                                    <span
                                        style={{
                                            color: "#f444f0",
                                            fontWeight: 600,
                                        }}
                                    >
                                        ● &nbsp;
                                    </span>
                                    Followers
                                </Typography>
                            </Box>
                        </Box>
                    )}
            </Box>
        </Box>
    );
};

export default Views;
